module.exports = __webpack_public_path__ + "static/media/slider_dolly.ebae3d80.png";